// extracted by mini-css-extract-plugin
module.exports = {"parts-diagram":"parts-diagram_parts-diagram__9Wdbi","dragging":"parts-diagram_dragging__3oekO","parts-diagram-wrapper":"parts-diagram_parts-diagram-wrapper__VK4sL"};